import { Permissions, PermissionDetails, everyPermission } from './permissions';

/**
 * The permissions that are for one part of the menu, like "Reports" or "Shipping". A menu section is shown to
 * someone who holds any of them.
 * @param section The first part of how the permission is shown: "Reports" for "Reports > Accounting > Credits"
 */
export const permissionsIn = (section: string): Permissions[] => {
    return everyPermission()
        .filter(x => PermissionDetails[x].display === section || PermissionDetails[x].display.indexOf(`${ section } > `) === 0);
};

/** Every permission there is */
export const allPermissions = (): Permissions[] => everyPermission();

/** The permissions for each part of the menu */
export const AnyReport          = permissionsIn('Reports');
export const AnyTransportationReport = permissionsIn('Reports > Transportation');
export const AnyProductionReport = permissionsIn('Reports > Production');
export const AnyAccountingReport = permissionsIn('Reports > Accounting');
export const AnyOrdering        = permissionsIn('Ordering');
export const AnyApproval        = permissionsIn('Approvals');
export const AnyRouting         = permissionsIn('Routing');
export const AnyProduction      = permissionsIn('Production');
export const AnyShipping        = permissionsIn('Shipping');
export const AnyInvoicing       = permissionsIn('Invoicing');
export const AnyCommunication   = permissionsIn('Communications');
export const AnyInventory       = permissionsIn('Inventory');
export const AnySupport         = permissionsIn('Support');
